module.exports = __webpack_public_path__ + "static/media/dpdecor-mokuf.4b4c26b8.png";